import { render, staticRenderFns } from "./homeMenuHeader.vue?vue&type=template&id=a48c0cf8"
import script from "./homeMenuHeader.vue?vue&type=script&lang=js"
export * from "./homeMenuHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports